angular.module('impactx.panel').directive('ixProductPanel', function() {
    return {
        restrict: 'EA',
        controller: 'ProductPanelCtrl',
        controllerAs: 'productPanelCtrl',
        scope: true,
        bindToController: {
            product: "=",
            hideOptions: "=",
            preConfiguredProducts: "=",
            fullyConfigured: "="
        },
        templateUrl: 'shared/panel/templates/product.panel.tmpl.html'
    }
});